/**
 * Old links "/?dest=?view=gantt&node=T-012" (still in email inboxes and Todoist tasks): the old view's new page.
 * The views are the old ALLOWED_DEST_VIEWS_, plus outputs and guides.
 */
const DEST_PAGE = {
  apply: '/apply',
  myapplications: '/my-applications',
  inbox: '/inbox',
  suggest: '/suggest',
  suggestions: '/suggestions',
  gantt: '/gantt',
  comments: '/comments',
  outputs: '/outputs',
  management: '/management',
  topics: '/topics',
  network: '/network',
  admin: '/admin',
  users: '/users',
  guides: '/guides',
} as const;

export type DestPage = (typeof DEST_PAGE)[keyof typeof DEST_PAGE];

/** The pages that open one task (?node=) or one application (?app=). */
const NODE_PAGES: readonly string[] = ['/gantt', '/comments', '/outputs'];
const APP_PAGES: readonly string[] = ['/inbox', '/my-applications'];

/**
 * `dest` ("?view=inbox&app=APP-1") → the new page and the node= / app= it takes.
 * No known view: `page` undefined, and `node` is kept for the Gantt ("/" sends a member there).
 * `thread`: an old Gantt link with a node opened that task's comment thread (DP:7684). These are the
 * thread mail's "respond" link (DP:5514) and the Todoist description (AgendaSync.gs:560).
 */
export function oldDest(dest: string): { page?: DestPage; node?: string; app?: string; thread?: true } {
  const q = new URLSearchParams(dest.replace(/^\?/, ''));
  const view = q.get('view') ?? '';
  const page = Object.hasOwn(DEST_PAGE, view) ? DEST_PAGE[view as keyof typeof DEST_PAGE] : undefined;
  const node = q.get('node') || undefined;
  const app = q.get('app') || undefined;
  return {
    ...(page ? { page } : {}),
    ...(node && (!page || NODE_PAGES.includes(page)) ? { node } : {}),
    ...(node && page === '/gantt' ? { thread: true as const } : {}),
    ...(app && page && APP_PAGES.includes(page) ? { app } : {}),
  };
}
